import { render } from "./HeroiconsSolidArrowRight.vue?vue&type=template&id=1e952ad3"
const script = {}

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowRight.vue"]])

export default __exports__